export interface LocationTableColumn {
    headerName: string;
    variant: LocationTableColumnTypes,
}

export enum LocationTableColumnTypes {
    NAME = 'customer-name',
    TOTAL_ORDERS_COUNT = 'total-orders-count',
    TOTAL_WEIGHT = 'total-weight',
    TOTAL_PAYMENTS = 'total-payments',
    ACTIONS = 'actions',
    ADD_ORDER = 'add-order'
}